import Icon from '@/components/ui/AppIcon';
import AppImage from '@/components/ui/AppImage';

interface ProcessStepProps {
  step: {
    number: number;
    title: string;
    description: string;
    icon: string;
    image: string;
    imageAlt: string;
    details: string[];
  };
  isReversed?: boolean;
}

export default function ProcessStep({ step, isReversed = false }: ProcessStepProps) {
  return (
    <div className={`flex flex-col ${isReversed ? 'lg:flex-row-reverse' : 'lg:flex-row'} items-center gap-8 lg:gap-12`}>
      <div className="flex-1 space-y-4">
        <div className="inline-flex items-center space-x-3">
          <div className="w-12 h-12 bg-primary/10 dark:bg-primary/20 rounded-full flex items-center justify-center">
            <span className="text-xl font-heading font-bold text-primary">{step.number}</span>
          </div>
          <div className="w-12 h-12 bg-primary/10 dark:bg-primary/20 rounded-full flex items-center justify-center">
            <Icon name={step.icon as any} size={24} className="text-primary" />
          </div>
        </div>
        
        <h3 className="text-2xl lg:text-3xl font-heading font-bold text-foreground">
          {step.title}
        </h3>
        
        <p className="text-lg text-muted-foreground">
          {step.description}
        </p>
        
        <ul className="space-y-3">
          {step.details.map((detail, index) => (
            <li key={index} className="flex items-start space-x-3">
              <Icon name="CheckCircleIcon" size={20} className="text-success mt-0.5 flex-shrink-0" />
              <span className="text-foreground">{detail}</span>
            </li>
          ))}
        </ul>
      </div>
      
      <div className="flex-1 w-full">
        <div className="relative rounded-lg overflow-hidden shadow-lg dark:shadow-cyan-glow/20 bg-card border border-border">
          <AppImage
            src={step.image}
            alt={step.imageAlt}
            className="w-full h-64 lg:h-80 object-cover"
          />
        </div>
      </div>
    </div>
  );
}